import React from 'react';
import { useSelector } from 'react-redux';


const ColorSchemaPreviewModernPremiumStore = () => {
  const {stylePalette = {}} = useSelector((state) => state.styles_palette);

  const colorsToPreview = {
    headerTopBgColor: stylePalette.header['theme_design/header/top_border_color'],
    headerBgColor: stylePalette.header['theme_design/header/header_bg_color'],
    headerColor: stylePalette.header['theme_design/header_primary/text_color'],
    buttonBgColor: stylePalette.buttons['theme_design/colors/button_bg_color'],
    buttonColor: stylePalette.buttons['theme_design/colors/button_color'],
    menuBgColor: stylePalette.menu['theme_design/nav/outer_menu_bg_color'],
    menuColor: stylePalette.menu['theme_design/nav/color'],
    footerBgColor: stylePalette.footer['theme_design/footer/bg_color'],
    footerColor: stylePalette.footer['theme_design/footer/color'],
    footerBottomBgColor: stylePalette.footer['theme_design/footer_bottom/bg_color'],
    footerBottomColor: stylePalette.footer['theme_design/footer_bottom/color'],
    ctaColor: stylePalette.homepage_cta['theme_design/cta/cta_mask_bg'],
    textColor: stylePalette.colors['theme_design/colors/color_primary_text_color'],
  };

  const {
    headerTopBgColor,
    headerBgColor,
    headerColor,
    buttonBgColor,
    buttonColor,
    menuBgColor,
    menuColor,
    footerBgColor,
    footerColor,
    footerBottomBgColor,
    footerBottomColor,
    ctaColor,
    textColor
  } = colorsToPreview;

  return (
    <div>
      <div className="min-h-8" style={{backgroundColor: `${headerTopBgColor}`}} />
      <div className="flex items-center justify-evenly py-8" style={{backgroundColor: `${headerBgColor}`}}>
        <div className="w-full">
          <div className="min-h-12 mx-10" style={{backgroundColor: `${headerColor}`}} />
        </div>
        <div className="uppercase w-full text-center text-24" style={{color: `${headerColor}`}}>logo</div>
        <div className="w-full">
          <div className="min-h-12 mx-5" style={{backgroundColor: `${headerColor}`}} />
        </div>
      </div>
      <div className="flex items-center justify-center px-2 py-4"  style={{backgroundColor: `${menuBgColor}`}}>
        <div className="flex items-center justify-between w-full max-w-400">
          <div className="min-w-60 min-h-4" style={{backgroundColor: `${menuColor}`}} />
          <div className="min-w-40 min-h-4" style={{backgroundColor: `${menuColor}`}} />
          <div className="min-w-80 min-h-4" style={{backgroundColor: `${menuColor}`}} />
          <div className="min-w-40 min-h-4" style={{backgroundColor: `${menuColor}`}} />
          <div className="min-w-40 min-h-4" style={{backgroundColor: `${menuColor}`}} />
        </div>
      </div>
      <div className="flex-column items-center justify-center max-w-360 w-full m-auto px-8 mt-8 mb-2">
        <div className="w-full min-h-16 max-w-80 my-5" style={{backgroundColor: `${textColor}`}} />
        <div className="w-full min-h-8 mt-1 mb-3" style={{backgroundColor: `${textColor}`}} />
        <div className="w-full min-h-8 max-w-80full" style={{backgroundColor: `${textColor}`}} />
        <div className="w-full max-w-100 flex justify-center border-radius-8 my-4" style={{backgroundColor: `${buttonBgColor}`}}>
          <div className="w-full min-h-4 max-w-40 mx-4 my-3" style={{backgroundColor: `${buttonColor}`}} />
        </div>
      </div>
      <div className="flex-column items-center justify-center max-w-360 w-full m-auto px-2 mb-6">
        <div className="flex justify-between w-full max-w-360 mx-auto my-4">
          <div className="w-full max-w-140 min-h-176 mr-4" style={{backgroundColor: `${ctaColor}`}} />
          <div className="flex-column items-center justify-between w-full max-w-240">
            <div className="w-full min-h-80 mb-2" style={{backgroundColor: `${ctaColor}`}} />
            <div className="w-full min-h-80" style={{backgroundColor: `${ctaColor}`}} />
          </div>
        </div>
      </div>
      <div className="w-full min-h-100 px-4 pt-8" style={{backgroundColor: `${footerBgColor}`}}>
        <div className="flex max-w-400 mx-auto">
          <div className="flex-column w-full max-w-200 mr-4">
            <div className="flex w-full mb-4">
              <div className="flex-column w-full max-w-150full">
                <div className="flex w-full max-w-80full">
                  <div className="h-8 w-32 mb-2 mr-2" style={{backgroundColor: `${footerColor}`}} />
                  <div className="h-8 w-32 mb-2 mr-2" style={{backgroundColor: `${footerColor}`}} />
                </div>
                <div className="flex w-full">
                  <div className="h-16 w-full bg-white" style={{border: `1px solid ${footerColor}`}} />
                  <div
                    className="w-full flex justify-center ml-1 max-w-40"
                    style={{backgroundColor: `${buttonBgColor}`}}
                  >
                    <div className="w-full min-h-4 my-1 mx-3" style={{backgroundColor: `${buttonColor}`}} />
                  </div>
                </div>
                <div className="h-4 mt-2" style={{backgroundColor: `${footerColor}`}} />
                <div className="h-4 mt-2 mb-2" style={{backgroundColor: `${footerColor}`}} />
              </div>
            </div>
          </div>
          <div className="flex-column w-full max-w-60 ml-4">
            <div className="flex-column w-full mb-4">
              <div>
                <div className="h-4 w-60 mb-2" style={{backgroundColor: `${footerColor}`}} />
                <div className="h-4 w-60 mb-2" style={{backgroundColor: `${footerColor}`}} />
                <div className="h-4 w-60 mb-2" style={{backgroundColor: `${footerColor}`}} />
              </div>
            </div>
          </div>
          <div className="flex-column w-full max-w-100 ml-4">
            <div className="flex-column w-full mb-4">
              <div>
                <div className="h-4 w-100 mb-2" style={{backgroundColor: `${footerColor}`}} />
                <div className="h-4 w-100 mb-2" style={{backgroundColor: `${footerColor}`}} />
                <div className="h-4 w-100 mb-2" style={{backgroundColor: `${footerColor}`}} />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="w-full min-h-40 flex items-center justify-center" style={{backgroundColor: `${footerBottomBgColor}`}}>
        <div className="flex">
          <div className="w-12 h-12 mr-2 rounded" style={{border: `1px solid ${footerBottomColor}`}} />
          <div className="w-12 h-12 mr-2 rounded" style={{border: `1px solid ${footerBottomColor}`}} />
          <div className="w-12 h-12 mr-8 rounded" style={{border: `1px solid ${footerBottomColor}`}} />
        </div>
        <div className="w-full max-w-60 mr-2 min-h-4" style={{backgroundColor: `${footerBottomColor}`}} />
        <div className="w-full max-w-60 mr-2 min-h-4" style={{backgroundColor: `${footerBottomColor}`}} />
        <div className="w-full max-w-60 mr-2 min-h-4" style={{backgroundColor: `${footerBottomColor}`}} />
        <div className="w-full max-w-60 min-h-4" style={{backgroundColor: `${footerBottomColor}`}} />
      </div>
    </div>
  );
};

export default ColorSchemaPreviewModernPremiumStore;
